export default __webpack_public_path__ + "static/media/abroadmbbsbanner.d5cd11c8.jpg";